import * as React from 'react';
import {useContext, useState} from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import MenuItem from '@mui/material/MenuItem';
import CustomLogo from "../CustomLogo";
import {Diversity1, LocalPolice, Logout, WorkspacePremium} from "@mui/icons-material";
import {appName} from "../../config";
import {
    alpha,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Divider,
    ListItemIcon
} from "@mui/material";
import {GlobalContext} from "../../state/global";
import CustomTooltip from "../CustomTooltip";
import {auth} from "../../firebase/clientApp";
import {useNavigate, useParams} from "react-router-dom";
import {setSelectedRoute} from "../../state/global/globalActions";
import {QrCodeAppCheckin} from "../../pages/Login";
import {customTheme, paletteKampaay} from "../../theme/customTheme";
import CustomMenu from "./CustomMenu";
import {useAuthContext} from "../../auth/hooks";

const CustomAppBar = () => {
    const {event_id} = useParams()
    const {user, logout} = useAuthContext();
    const [globalState, dispatch] = useContext(GlobalContext)

    const navigate = useNavigate()

    const name = user.name || ''
    const email = user.email || 'email'
    //const {email} = AuthService.getCurrentUserData()
    const [anchorElUser, setAnchorElUser] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    function handleOpenConfirmDialog() {
        setOpenConfirmDialog(!openConfirmDialog)
    }

    function handleGoToCheckIn() {
        window.open(`${window.location.origin.toString()}/${event_id}/checkin`, '_blank');
        //navigate(`/${event_id}/checkin`)
    }

    const settings = [{
        label: `Account ${user?.role || ''}`,
        icon: user?.role === 'ADMIN'
            ? <LocalPolice/> : user?.role === 'AGENCY'
                ? <Diversity1/> : <WorkspacePremium/>,
        action: handleCloseUserMenu
    }, {
        label: 'App Check-In',
        icon: <QrCodeAppCheckin size={'small'} color={'grey'}/>,
        action: handleGoToCheckIn
    }, {
        label: 'Logout',
        icon: <Logout/>,
        action: handleOpenConfirmDialog
    }];

    const logOut = () => {
        logout()
        navigate(`/`, {replace:true})
        dispatch(setSelectedRoute('/'))
        /* auth.signOut().then(() => {
            //navigate(`/${event_id}/login`, {replace:true})
            navigate(`/RGfGHSMClYCvoLmwVNNb/login`, {replace:true})
            dispatch(setSelectedRoute('/'))
        }).catch((error) => {
            // An error happened.
        }); */
    }

    function handleLogout() {
        logOut()
    }

    return (
        <AppBar position="sticky" color={'transparent'} sx={{top: '-60px'}}>
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Box px={1} flexGrow={1} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                        <CustomLogo width={'210px'} bw={false}/>
                        <Typography sx={{marginLeft: 'auto', marginRight: 1}} variant={'inherit'} textAlign="center">
                            {globalState?.settings?.eventName || appName}
                        </Typography>
                        <Box>
                            <CustomTooltip
                                title="Apri menù"
                                children={<IconButton onClick={handleOpenUserMenu} sx={{p: 0}}>
                                            <img src={globalState.settings?.logoUrl}
                                                 style={{
                                                     width: '80px',
                                                     //height: '50px',
                                                     objectFit: 'cover',
                                                     borderRadius: '0.5rem',
                                                     padding: 10,
                                                     borderColor: alpha(paletteKampaay.neutral, 0.2),
                                                     borderWidth: 1,
                                                     borderStyle: 'solid'
                                                     //background: alpha(paletteKampaay.neutral, 0.2)
                                                 }}>
                                            </img>
                                        </IconButton>}
                            />
                            <Menu
                                sx={{mt: '45px'}}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                            >
                                <Box px={2} pb={1} pt={0}>
                                    <Typography variant={'body2'}
                                                textAlign={'right'}
                                                color={customTheme.palette.accent.main}
                                    >
                                        {name}
                                        <br/>
                                        {email}
                                    </Typography>
                                </Box>
                                <Divider/>
                                {settings.map((setting) => (
                                    <MenuItem key={setting.label} onClick={setting.action}>
                                        <ListItemIcon>
                                            {setting.icon}
                                        </ListItemIcon>
                                        <Typography textAlign="center">{setting.label}</Typography>
                                    </MenuItem>
                                ))}
                                <Dialog open={openConfirmDialog} onClose={handleOpenConfirmDialog}>
                                    <DialogContent>
                                        <DialogContentText>
                                            Sei sicuro di voler uscire?
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <DialogActions>
                                            <Button onClick={handleOpenConfirmDialog}>Annulla</Button>
                                            <Button onClick={handleLogout} variant={'submit'}
                                                    startIcon={<Logout/>}>Esci
                                            </Button>
                                        </DialogActions>
                                    </DialogActions>
                                </Dialog>
                            </Menu>
                        </Box>
                    </Box>
                </Toolbar>
                <CustomMenu/>
            </Container>
        </AppBar>
    );
}
export default CustomAppBar;
